var _rect, _path, _path2, _circle, _circle2, _circle3, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "url(#gradient-bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 400C200 350 400 500 600 450C800 400 1000 300 1200 350C1400 400 1600 450 1920 400V1080H0V400Z",
    fill: "url(#shape-gradient)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 600C200 550 400 700 600 650C800 600 1000 500 1200 550C1400 600 1600 650 1920 600V1080H0V600Z",
    fill: "url(#shape-gradient)",
    fillOpacity: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 100,
    fill: "#2B5876",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1720,
    cy: 300,
    r: 150,
    fill: "#4E4376",
    fillOpacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 960,
    cy: 150,
    r: 80,
    fill: "#FF6B6B",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1920v1080h-1920z",
    fill: "url(#grid-pattern)",
    fillOpacity: 0.03
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-bg",
    x1: 0,
    y1: 0,
    x2: 1920,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E9ECEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-gradient",
    x1: 0,
    y1: 0,
    x2: 1920,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2B5876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#4E4376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6B6B"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "grid-pattern",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40 0 L 0 0 0 40",
    fill: "none",
    stroke: "#2B5876",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactBg);
export default __webpack_public_path__ + "static/media/contact-bg.b9b7ef206fb189f5bedc63c94e8b76cb.svg";
export { ForwardRef as ReactComponent };